import React from "react";
import DoubleButton from "../../ui/DoubleButton";
import BottomBar from "../../BottomBar/BottomBar";
import { getCheerersPeriod } from "../../../../../common/constants/getCheerersPeriod";

interface TopCheersBottomBarProps {
  onButtonClick: (period: getCheerersPeriod) => void;
  cheerersListPeriod: getCheerersPeriod;
}

const TopCheersBottomBar: React.FC<TopCheersBottomBarProps> = ({ onButtonClick, cheerersListPeriod }) => {
  return (
    <BottomBar>
      <DoubleButton
        selected={cheerersListPeriod === getCheerersPeriod.lifetime ? "left" : "right"}
        onLeftClick={() => onButtonClick(getCheerersPeriod.lifetime)}
        onRightClick={() => onButtonClick(getCheerersPeriod.today)}
      />
    </BottomBar>
  );
};

export default TopCheersBottomBar;
